export const pageConstants = {
    PAGE_ATTACH: "PAGE_ATTACH",
    PAGE_SELECT: "PAGE_SELECT",
    DESELECT_PAGE_ELEMENT: "DESELECT_PAGE_ELEMENT",
    DELETE_PAGE_ELEMENT: "DELETE_PAGE_ELEMENT",

    SOFT_UPDATE_PAGE: "SOFT_UPDATE_PAGE",
    

    UPDATE_PAGE_SUCCESS: "UPDATE_PAGE_SUCCESS",
    UPDATE_PAGE_REQUEST: "UPDATE_PAGE_REQUEST",
    UPDATE_PAGE_FAILURE: "UPDATE_PAGE_FAILURE",
  
    GET_PAGE_REQUEST: "GET_PAGE_REQUEST",
    GET_PAGE_SUCCESS: "GET_PAGE_SUCCESS",
    GET_PAGE_FAILURE: "GET_PAGE_FAILURE",

      
    GET_ALL_PAGE_PATHS: 'GET_ALL_PAGE_PATHS',

    GET_PAGES_BY_REQUEST: "GET_PAGES_BY_REQUEST",
    GET_PAGES_BY_SUCCESS: "GET_PAGES_BY_SUCCESS",
    GET_PAGES_BY_FAILURE: "GET_PAGES_BY_FAILURE",
  
   
    UPDATE_PAGE_ELEMENT: "UPDATE_PAGE_ELEMENT",
  
    RESTORE_PAGE: "RESTORE_PAGE",
  
    ADD_VIEW_PAGE: "ADD_VIEW_PAGE",
    REMOVE_VIEW_PAGE: "REMOVE_VIEW_PAGE",
    NAVIGATE_PAGE: "NAVIGATE_PAGE"
/*     SCROLL_PAGE: "SCROLL_PAGE" */
  };
  